import { InjectionToken } from '@angular/core';
export var JWT_OPTIONS = new InjectionToken('JWT_OPTIONS');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@auth0/angular-jwt/src/jwtoptions.token.js
// module id = ./node_modules/@auth0/angular-jwt/src/jwtoptions.token.js
// module chunks = vendor